export default __webpack_public_path__ + "5a7a9c79aea81c6fc05c11d5cdb3729e.svg";